export default __webpack_public_path__ + "static/media/play_next_icon.c4be9bf6.svg";